import styled, { css } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";

export const _LandingEngagementsRoot = styled("section")<{
  $bg?: {
    desktop?: string;
    mobile?: string;
  };
  $linkColor?: string;
}>(({ $linkColor }) => {
  return css`
    padding: 48px 0px;

    @media ${responsiveMap.mobile} {
      padding: 48px 0px;
    }

    .landing-engagements {
      &__container {
        display: flex;
        flex-direction: column;
        gap: 48px;
        align-items: center;
        @media ${responsiveMap.mobile} {
          gap: 24px;
        }
      }
      &__header {
        max-width: 518px;
        gap: 13px;
        @media ${responsiveMap.mobile} {
          gap: 8px;
          padding: 0px 16px;
        }
      }

      &__description a {
        color: ${$linkColor || "inherit"};
        text-decoration: underline;
      }

      &__cover {
        width: 100%;
        aspect-ratio: 3 / 1;
        @media ${responsiveMap.mobile} {
          display: none;
        }
      }
    }
  `;
});

export const _LandingEngagementsProductList = styled("div")<{}>(({}) => {
  return {};
});
